<template>
  <div class="content-middle">
    <div class="cont-con clearfix">
      <div class="cont-left hidden-xs">
        <div class="contl-header">
          扫描枪
          <button class="menu-button" id="open-button">Open Menu</button>
        </div>
        <div class="menu-wrap">
          <nav class="menu">
            <div class="icon-list">
              <router-link
                :to="{path: list.url, query: {index: index}}"
                :class="{'current': currentIndex == index}"
                v-for="(list, index) in lists"
                v-bind:key="index"
              >{{list.text}}</router-link>
            </div>
          </nav>
          <button class="close-button" id="close-button">Close Menu</button>
        </div>
      </div>
      <div class="cont-right">
        <div class="contr-header clearfix">
          <h4>{{buname}}</h4>
          <div class="contr-nav">
            <router-link to="/">首页</router-link>&gt;
            <router-link :to="{path:'/SMQ',query: {index: 0}}">扫描枪</router-link>
            &gt; {{buname}}
          </div>
        </div>
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    this.buname = this.$route.meta.title;
    this.currentIndex = this.$route.query.index;
  },
  data() {
    return {
      currentIndex: 0,
      buname: "BU02",
      lists: [
        { text: "BU02", url: "/SMQ/02" },
        { text: "BU02PB", url: "/SMQ/02PB" }
      ]
    };
  },
  methods: {},
  watch: {
    $route(to, from) {
      if (to != undefined) {
        this.currentIndex = to.query.index;
        this.buname = to.meta.title;
      }
    }
  },
  components: {}
};
</script>

<style lang="stylus" scoped rel="stylesheet/stylus"></style>



// WEBPACK FOOTER //
// src/components/SMQ/SMQindex.vue